
import React from 'react';
import { Switch } from "@/components/ui/switch";
import { 
  isLovableEditor, 
  _DEBUG_forceEditorState,
  refreshEnvironmentDetection
} from "@/utils/environment";

interface EditorModeToggleProps {
  showLabel?: boolean;
  className?: string;
}

export function EditorModeToggle({ showLabel = true, className = "" }: EditorModeToggleProps) {
  const [isEditor, setIsEditor] = React.useState(() => isLovableEditor());

  const handleToggleEditorMode = (checked: boolean) => {
    _DEBUG_forceEditorState(checked);
    setIsEditor(checked);
    console.log(`[EditorModeToggle] Editor mode ${checked ? 'enabled' : 'disabled'}`);
  };

  // Refresh detection on mount to ensure accurate state
  React.useEffect(() => {
    const detectedMode = refreshEnvironmentDetection();
    setIsEditor(detectedMode);
  }, []);

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {showLabel && (
        <div className="flex flex-col">
          <span className="text-sm font-medium">Editor Mode</span>
          <span className="text-xs text-muted-foreground">
            {isEditor ? "Active" : "Inactive"}
          </span>
        </div>
      )}
      <Switch 
        checked={isEditor} 
        onCheckedChange={handleToggleEditorMode}
        aria-label="Toggle Editor Mode"
      />
    </div>
  );
}
